module.exports = __webpack_public_path__ + "src/assets/images/macys-logo.98fcc0b73e3b0b962f575e9ded5484d4.svg";